import Blocks from './blocks';
import Pages from './pages';
import * as Routes from './routes';

window.Routes = Routes;

import 'blueimp-file-upload/js/vendor/jquery.ui.widget.js';
import 'blueimp-file-upload/js/jquery.fileupload-image.js';
import 'blueimp-file-upload/js/jquery.iframe-transport.js';
import 'blueimp-file-upload/js/jquery.fileupload.js';
import 'blueimp-load-image/js/load-image-orientation';

$(() => {
    Blocks();
    Pages();
});
